import '.f4{display:inline-flex;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.am{height:40px;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.gx{transition-timing-function:ease-in-out;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.bi{inset:0px;}.ssr-plugin'
import '.w{pointer-events:none;}.ssr-plugin'
import React from 'react'
import { styled, Style } from 'inlines'
import { Overlay } from '../Overlay/index.js'
import { OverlayTrigger } from '../Overlay/OverlayTrigger.js'
import { OverlayContent } from '../Overlay/OverlayContent.js'
import { colors } from '../../tokens/colors.js'
import { shadows } from '../../utils/shadows.js'
import { radius } from '../../utils/radius.js'
import { Separator } from '../Separator/index.js'
import { IconButton } from '../IconButton/index.js'

type MiniSheetProps = {
  children?: React.ReactNode
  open?: boolean
  onClose?: () => void
  onOpen?: () => void
  style?: Style
}

const MiniSheet = ({
  children,
  open = false,
  onClose,
  onOpen,
  style,
}: MiniSheetProps) => {
  const triggerElement = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === OverlayTrigger,
  )

  const miniSheetItems = React.Children.toArray(children).filter(
    (child) => !React.isValidElement(child) || child.type === MiniSheetItems,
  )

  return (
    <Overlay
      position="bottom"
      scrollableParent
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      style={{ ...style }}
    >
      <Overlay.Trigger>{triggerElement}</Overlay.Trigger>
      <Overlay.Content
        style={{
          border: `1px solid  ${colors.neutral20Adjusted}`,
          boxShadow: shadows.popoverSmall,
          borderRadius: radius[16],
        }}
      >
        {miniSheetItems}
      </Overlay.Content>
    </Overlay>
  )
}

type MiniSheetSeparatorProps = {}

function MiniSheetSeparator({}: MiniSheetSeparatorProps) {
  return <Separator orientation="vertical" style={{ zIndex: 0 }} />
}

function MiniSheetItems({ children }: any) {
  return (
    <div className="f4 c d a3 am fj gx"
      style={{
        background: colors.neutralInverted100,
        borderRadius: radius[16],}}
    >
      <div className="p bi w"
        style={{
          borderRadius: radius[16],
          background: colors.neutral10Background,}}
      />
      {children}
    </div>
  )
}

function MiniSheetItem({ onClick, ...props }: any) {
  return (
    <IconButton
      {...props}
      onClick={(e) => {
        onClick?.(e)
        Overlay.Close()
      }}
    />
  )
}

MiniSheet.Trigger = OverlayTrigger
MiniSheet.Content = OverlayContent
MiniSheet.Items = MiniSheetItems
MiniSheet.Item = MiniSheetItem
MiniSheet.Separator = MiniSheetSeparator

export { MiniSheet }
